// Mock data for SteelSaints consulting website

export const mockData = {
  hero: {
    title: "Engineering Intelligence Into Every Decision",
    subtitle: "Empowering NYC businesses to dominate their markets through data analytics, intelligent automation, and AI integration that drives measurable outcomes.",
    ctaPrimary: "Schedule Consultation",
    ctaSecondary: "Explore Solutions"
  },
  services: [
    {
      id: 1,
      icon: "BarChart3",
      title: "Data Analytics",
      description: "Transform raw data into strategic intelligence. We help you understand your business metrics, customer behavior, and market dynamics to make decisions that matter.",
      features: ["Custom Analytics Dashboards", "Predictive Intelligence", "Performance Optimization", "Real-Time Visualization"]
    },
    {
      id: 2,
      icon: "Workflow",
      title: "Automation Solutions",
      description: "Eliminate inefficiency and scale operations. Our automation solutions free your team from repetitive work, reduce errors, and accelerate growth.",
      features: ["Process Automation", "Workflow Engineering", "System Integration", "Cost Optimization"]
    },
    {
      id: 3,
      icon: "Brain",
      title: "AI Integration",
      description: "Deploy artificial intelligence that delivers real results. From intelligent chatbots to predictive models, we implement AI solutions tailored to your competitive advantage.",
      features: ["Custom AI Models", "Conversational AI", "Machine Learning", "Intelligent Process Automation"]
    }
  ],
  caseStudies: [
    {
      id: 1,
      client: "Chelsmore Apartments",
      industry: "Real Estate",
      challenge: "Needed comprehensive spending and labor analysis to optimize operations and reduce costs across multiple properties.",
      solution: "Conducted in-depth 3-month analysis of spending patterns, labor allocation, and operational efficiency. Developed custom dashboards for real-time tracking and implemented data-driven recommendations.",
      results: [
        "25% reduction in operational costs",
        "Improved labor allocation efficiency",
        "Real-time expense tracking system",
        "Data-driven decision framework"
      ],
      duration: "3 months",
      testimonial: "The analytics and insights provided transformed how we manage our properties. We now have complete visibility into our spending and can make informed decisions quickly."
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "VP of Operations",
      company: "Chelsmore Real Estate",
      role: "Operations Management",
      content: "The analytics and insights provided transformed how we manage our properties. We now have complete visibility into our spending and can make informed decisions quickly.",
      rating: 5
    }
  ],
  about: {
    title: "Built for NYC Businesses",
    description: "SteelSaints specializes in data analytics, automation, and AI integration for businesses that refuse to settle for mediocrity. With 5 years of proven results across multiple industries, we deliver solutions that drive measurable impact.",
    expertise: [
      "5 years proven experience",
      "50+ successful implementations",
      "NYC market specialists",
      "Small business to enterprise"
    ]
  },
  contact: {
    email: "contact@steelsaints.net",
    location: "New York, NY",
    calendlyUrl: "https://calendly.com/steelsaints"
  }
};
